import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useEffect,
    useRef,
    useState,
} from 'react';

import {
    useClickOutside,
} from 'tools/hooks';

import DateTimeInput from '../DateTimeInput';
import StringInput from '../StringInput';

import {
    formatDisplayValue,
} from './functions';

import styles from './DateIntervalInput.module.scss';

const DateTimeIntervalInput: FC<IProps> = (props) => {
    const [fromValue, setFromValue] = useState(props.fromValue);
    const [toValue, setToValue] = useState(props.toValue);
    const [isOpen, setIsOpen] = useState(false);

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        props.onChangeValue?.(fromValue, toValue);
    }, [fromValue, toValue]);
    useClickOutside(containerRef, () => {
        setIsOpen(false);
    });

    return (
        <div
            ref={containerRef}
            className={classNames(styles.dateTimeIntervalInput, props.className)}
        >
            <StringInput
                label={props.label}
                size={props.size}
                value={formatDisplayValue(fromValue, toValue)}
                isDisabled={props.isDisabled}
                onFocus={() => setIsOpen(true)}
            />
            {
                isOpen &&
                <div className={styles.inputsCard}>
                    <DateTimeInput
                        label={`${props.label}: from`}
                        size={props.size}
                        value={fromValue}
                        isDisabled={props.isDisabled}
                        onChangeValue={setFromValue}
                    />
                    <DateTimeInput
                        label={`${props.label}: to`}
                        size={props.size}
                        value={toValue}
                        isDefaultEndDay={true}
                        isDisabled={props.isDisabled}
                        onChangeValue={setToValue}
                    />
                </div>
            }
        </div>
    );
};

export default DateTimeIntervalInput;
